module.exports = __webpack_public_path__ + "static/img/color.8606a000.jpg";